import React, { ReactNode } from 'react';
import styles from './assets/serviceType-list-screen.module.scss';
import classNames from 'classnames';
import ServiceTypesGrid from './components/ServiceTypesGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import CreateServiceTypeButton from './components/CreateServiceTypeButton';
import AdminLayout from 'src/components/layout/RoleLayout';
import { IServiceType } from 'src/types/service-types';
import Loader from '../../../../../../components/Loader';

export interface StateProps {
    data: Paginated<IServiceType>;
    inProgress: boolean;
    providers: SelectObject[];
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
    getProviders: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class ServiceTypeListScreen extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
        this.state = {
            columnOpen: false,
        };
    }
    componentDidMount() {
        this.props.getProviders({
            page: 1,
            itemsPerPage: 9000,
        });
    }

    public render(): ReactNode {
        const { data, getData, inProgress, providers } = this.props;

        return (
            <AdminLayout>
                {inProgress ? <Loader /> : null}
                <div className={`${classNames(styles.WrapPage)}`}>
                    <div className={`${classNames(styles.pageHeading)} ${'pageHeading'}`}>
                        <h2 className={`${classNames(styles.pageHeadingTitle)} ${'pageHeadingTitle'}`}>
                            SERVICE TYPES {data.totalCount ? '(' + data.totalCount + ')' : ''}
                        </h2>
                        <CreateServiceTypeButton />
                    </div>
                    <div className={classNames(styles.list)}>
                        <ServiceTypesGrid data={data} getData={getData} providers={providers} />
                    </div>
                </div>
            </AdminLayout>
        );
    }
}

export default ServiceTypeListScreen;
